import { render, staticRenderFns } from "./radioInput.vue?vue&type=template&id=6539c6f2&scoped=true&"
import script from "./radioInput.vue?vue&type=script&lang=ts&"
export * from "./radioInput.vue?vue&type=script&lang=ts&"
import style0 from "./radioInput.vue?vue&type=style&index=0&id=6539c6f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6539c6f2",
  null
  
)

export default component.exports